import React, { useEffect } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import dayjs from 'dayjs';
import { Button, Space, Tooltip } from 'antd';
import { useRecoilValue } from 'recoil';
import { checkPermissions } from '../../../utils/permissions';
import { appConfigAtomState } from '../../../state/reducerAtoms/app.atom';
import AppTable from '../../../components/table/index';
import { showSnackbar } from '../../../components/snackbar/index';
import { getCurrentFacilityURL } from '../../../helpers/helper.functions';
import { translateThis } from '../../../helpers/language.helper';
import { DATE_FORMAT } from '../../../constants';
import PageLayout from '../../app';
import SVGIcons from '../../../assets/images/icons/svgIcons';





const GMAIL_ERROR_MESSAGES = {
    access_denied: 'Gmail connection was denied or cancelled.',
    missing_code: 'Gmail authorization did not return a code.',
    invalid_state: 'Invalid state; please try connecting again.',
    server_error: 'A server error occurred during Gmail connection.',
};

const AIModuleList = () => {
    const appState = useRecoilValue(appConfigAtomState);
    const facilityURL = getCurrentFacilityURL();
    const navigator = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const profile = appState?.profile || {};

    // Handle OAuth error redirect: ?gmail=error&message=... (backend redirects to .../atc/ai-development or .../modules)
    useEffect(() => {
        const gmailParam = searchParams.get('gmail');
        const messageParam = searchParams.get('message');
        if (gmailParam === 'error' && messageParam) {
            const msg = GMAIL_ERROR_MESSAGES[messageParam] || translateThis('Gmail connection failed');
            showSnackbar().failure(msg);
            const next = new URLSearchParams(searchParams);
            next.delete('gmail');
            next.delete('message');
            setSearchParams(next, { replace: true });
        }
    }, [searchParams]);




    

    const actionsColumn = {
        title: `${translateThis('Actions')}`,
        dataIndex: 'actions',
        key: 'actions',
        width: 150,
        render: (_, record) => {
            const moduleEmbeddedURL = `${process.env.REACT_APP_AI_APP_URL}/${getCurrentFacilityURL()}/chat/${record.name}`;
            return (
                <Space size={6} className='action-table-btns'>
                    {checkPermissions(profile, "See Agents") && (
                        <Tooltip title={translateThis('View')}>
                            <Button shape="circle" onClick={() => navigator(`/${getCurrentFacilityURL()}/ai-development/view-module/${record.id}`, { state: { data: record } })}>
                                <SVGIcons.EyeOpen />
                            </Button>
                        </Tooltip>
                    )}
                    {checkPermissions(profile, "Edit Agents") && (
                        <Tooltip title={translateThis('Edit')}>
                            <Button shape="circle" onClick={() => navigator(`/${getCurrentFacilityURL()}/ai-development/edit-module/${record.id}`, { state: { data: record } })}>
                                <SVGIcons.EditIcon />
                            </Button>
                        </Tooltip>
                    )}
                    <Tooltip title={translateThis('Deploy')}>
                        <Button shape="circle" onClick={() => window.open(moduleEmbeddedURL, '_blank')}>
                            <SVGIcons.RocketIcon />
                        </Button>
                    </Tooltip>
                </Space>
            );
        },
    };

    const tableColumns = [
        {
            title: `${translateThis('Title')}`,
            dataIndex: 'title',
            key: 'title',
            onCell: () => ({
                style: { minWidth: 160 },
            }),
            width: 256,
            ellipsis: true,
        },
        {
            title: `${translateThis('Use case')}`,
            dataIndex: 'useCase',
            key: 'useCase',
            width: 570,
            ellipsis: true,
        },
        {
            title: `${translateThis('For use of')}`,
            dataIndex: 'roleId',
            key: 'roleId',
            width: 170,
            ellipsis: true,
            render: (text, record) => <>{((record?.roleId?.roleName === 'university') || (record?.roleId?.roleName === 'admin') ? `${translateThis('Internal')}` : `${translateThis('Public')}`) || ''}</>
        },
        {
            title: `${translateThis('Created at')}`,
            dataIndex: 'createdAt',
            key: 'createdAt',
            width: 165,
            ellipsis: true,
            render: (text, record) => dayjs(record?.createdAt).format(DATE_FORMAT)
        },
        actionsColumn,
    ];

    const getDataURL = () => `modules`;



    return (
        <>
            {checkPermissions(profile, "See Agents") ?
                <PageLayout
                    pageName={'Ai Modules'}
                    pageTitle={'Ai Modules'}
                    bodyClassName={`module-main-wrp`}
                    key={`${appState?.selectedLang}`}
                >
                    <div className="container">
                        <div className="main-content-wrapper AI-module-list f-wrp">

                            {tableColumns.length > 0 ? null : <div className='module-create-box'>
                                {
                                    checkPermissions(profile, "Create Admin User") &&
                                    <Link className='create-module-btn' to={`/${facilityURL}/ai-development/new-module`}>{translateThis('Create a new Agent')}</Link>
                                }
                            </div>}


                            <div className="module-list-box appTable-list f-wrp">
                                <div className='btn-header'>
                                    {
                                        checkPermissions(profile, "Create Admin User") &&

                                        <Link className='create-module-btn' to={`/${facilityURL}/ai-development/new-module`}>{translateThis('Create a new Agent')}</Link>
                                    }
                                </div>

                                <AppTable
                                    columns={tableColumns}
                                    dataURL={getDataURL()}
                                    isRefreshData
                                    isEditActionEnabled={false}
                                    isViewActionEnabled={false}
                                    isDeleteActionEnabled={false}
                                    actionColumnSettings={{ width: 1 }}
                                />
                            </div>
                        </div>

                    </div>
                </PageLayout > : <PageLayout
                    pageName={'No Access'}
                    pageTitle={'No Access'}
                    bodyClassName={`module-main-wrp no-access-page`}
                    key={`${appState?.selectedLang}`}
                >
                    <div className="container">
                        <div className="main-content-wrapper AI-module-list f-wrp">
                            <div className='no-access-box'>
                                <div className='no-access-title'>
                                    <h2 style={{ color: '#fff', textAlign: 'center' }}>{translateThis('No Access')}</h2>
                                </div>
                            </div>
                        </div>
                    </div>
                </PageLayout>}
        </>

    )
}
AIModuleList.propTypes = {}

export default AIModuleList;
